// extracted by mini-css-extract-plugin
export default {"text":"ErrorMessage_text__77DSU","video":"ErrorMessage_video__0wBiU"};